export default __webpack_public_path__ + "static/media/skull.2965bb6c.webp";